
+function(e) {
  const LOG_URL = "http://pool.51yxedu.com/index.php/pool/Index/p?";
  
  // var parseBaseParam = function () {
  //   function e(yxLog) {
  //     console.log(yxLog,n)
  //     if (n) {
  //       return n
  //     }
  //     var args='';
  //     for(var i in yxLog) {
  //       console.log(i)
  //       args += i + '=' + encodeURIComponent(yxLog[i]) +'&';
  //       console.log(args)
  //     }
  //     args = args.slice(0 ,args.length-1)
  //     n =args;
  //   }
  //   var n;
  //   return e
  // } ();
  var params ={};

  function getUserInfo(){
    if(params.userid) return;
    var info = sessionStorage.getItem('user_info');
    if(info){
      var user = JSON.parse(info);
      params.userid =user.userId;
      params.course_id =user.courseId;
      params.section_id =user.sectionId;
      params.topic_id =user.topicId;
      // yxLog.course_type =user.courseId;
    }
  }

  function sendLog(customsParams={}) {
    getUserInfo();
    params.time_stamp = (new Date()).getTime();
    params = Object.assign(params,customsParams)
    

    var args = '';
    for(var i in params) {
        args +='&' + i + '=' + encodeURIComponent(params[i]);
    }
    args = args.slice(1 ,args.length)
    console.log(LOG_URL+args);
    
    (new Image).src = LOG_URL+args;
  }
    window.yxH5Log = sendLog;
} ();


// WEBPACK FOOTER //
// ./src/utils/yxLog.js